export interface Space {
  total: { total: number }
  versioning: { total: number }
  used: { total: number }
  publicsharing: { enabled: boolean }
  securesync: {
    enabled: boolean
    total: number
    folder_count: number
    file_count: number
    share_request: number
    share_request_expired: number
  }
  securevault: {
    enabled: boolean
    total: number
    folder_count: number
    file_count: number
    share_request: number
    share_request_expired: number
  }
  secureinbox: {
    enabled: boolean
    total: number
    new_doc_count: number
    doc_count: number
    share_request: number
    share_request_expired: number
  }
  securepassword: {
    enabled: boolean
    count_pwd: number
  }
  no_space_left: boolean
}

export interface User {
  commit_count: number
}

export const defaultSpace: Space = {
  total: { total: 0 },
  versioning: { total: 0 },
  used: { total: 0 },
  publicsharing: { enabled: false },
  securesync: {
    enabled: false,
    total: 0,
    folder_count: -1,
    file_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  securevault: {
    enabled: false,
    total: 0,
    folder_count: 0,
    file_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  secureinbox: {
    enabled: false,
    total: 0,
    new_doc_count: 0,
    doc_count: 0,
    share_request: 0,
    share_request_expired: 0,
  },
  securepassword: { enabled: false, count_pwd: 0 },
  no_space_left: false,
}

export const defaultUser: User = { commit_count: 0 }
